import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, Col, Container, Row } from 'reactstrap';
import { getSingleMessage } from '../redux/actions/futuremessage.action';

function FutureMessages_main(props) {
	const dispatch = useDispatch();
	const { single_message } = useSelector(state => state.future_message);
	const authUser = useSelector(state => state.authUser);
	useEffect(() => {
		dispatch(getSingleMessage(props.match.params.id));
	}, []);
	return (
		<>
			<Container className='mt-5'>
				<div
					style={{ width: '100%', maxWidth: '380px' }}
					className='text-center mx-auto'
				>
					<h1
						className='text-uppercase section-title'
						style={{
							fontFamily: 'Ogg',
							letterSpacing: 6,
							wordSpacing: 8,
						}}
					>
						Future Message
					</h1>
					<p>Your Future Message</p>
				</div>
				{/* {
                authUser
                    ? */}
				<Row className='justify-content-center'>
					<Col md='6'>
						{single_message && (
							<>
								<div className='message_image'>
									<img
										src={
											single_message.media_files &&
											single_message.media_files[0]
										}
										alt='future message media'
									/>
								</div>
								<div className='my-3'>
									<h4 className='font-weight-bold'>
										to: {single_message.send_to}
									</h4>
									<p className='my-3'>
										{single_message.message}{' '}
									</p>
									<small className='font-weight-bold'>
										Delivery date
									</small>
									<hr className='my-2' />
									<div className='d-flex align-items-center'>
										<small>
											{single_message.deliveryDate}
										</small>
										<small className='ml-3'>
											{single_message.deliveryTime}
										</small>
									</div>
								</div>
							</>
						)}
					</Col>
				</Row>
				{/* :
                    <div className="text-center mt-5 mb-5">
                        <p>
                            Login to see message
                        </p>
                        <Link to="/dashboard/register">
                            <Button className='btn-outline dashboard-btn'>Login</Button>
                        </Link>
                    </div>
            } */}
			</Container>
		</>
	);
}

export default FutureMessages_main;
